<template>

</template>

<script>
  export default {
     name: 'Property_Insert_Data',
     data () {
       return {
          
        };
     },
     methods: {
    
     }
   }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Property/Property_Insert_Data.vue